import { ToolUse } from "bundles/BigqueryQueryViewer/store/chat";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Button } from "react-bootstrap";
import * as styles from "./style.module.css";

interface ChoicesProps {
  toolUse: ToolUse;
  isLast: boolean;
  onToolResponse: (tool: ToolUse, response: unknown) => void;
}

export const Choices = observer((props: ChoicesProps) => {
  const { toolUse, isLast, onToolResponse } = props;

  const choices = toolUse.parameters
    .filter((_) => _.key == "choice")
    .map((_) => _.value);

  return (
    <div className={styles.root}>
      {choices.map((choice, i) => (
        <Button
          variant="outline-primary"
          size="sm"
          key={i}
          className={styles.button}
          disabled={!isLast}
          onClick={() => onToolResponse(toolUse, { choice })}
        >
          {choice}
        </Button>
      ))}
    </div>
  );
});
